import NumberFormat from 'react-number-format';

export const CurrencyFormatDisplay = ({
  value,
  prefix = '$',
}: {
  value: string | number;
  prefix?: string;
}) => {
  return (
    <NumberFormat
      value={value}
      displayType={'text'}
      thousandSeparator={true}
      prefix={prefix}
    />
  );
};
